import { render, staticRenderFns } from "./FiBuSumList.vue?vue&type=template&id=56640c14&"
import script from "./FiBuSumList.vue?vue&type=script&lang=js&"
export * from "./FiBuSumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports